import React from "react";
import "./pfButton.css";
import { Button } from "antd";
import PropTypes from "prop-types";

/**
 * PFButton takes in some props: isDisabled, content (when it's a text button), clickCallback, isLoading, isBlock, currentSize, currentIcon, currentWidth, currentHeight width and heigth
 * block is a boolean prop that we need when we don't have size prop populated
 * size can be "small", "middle", "large"
 * when block is true button takes the width.
 * */
const PFButton = ({
  isDisabled = false,
  type = "primary",
  content = null,
  isLoading = false,
  isBlock = false,
  floatRight = false,
  className = "",
  clickCallback,
  currentSize,
  currentIcon,
  currentWidth,
  htmlType,
}) => {
  /**
   * this method returns a class for styling the button BUT the only existing class at the moment is "pf-btn-transparent"
   * We've had to delete the others because they didn't behave correctly on :hover and on :focus
   * so we have to overwrite ant button classes
   * */

  const getCurrentClassName = () => {
    let currentClassName = null;
    switch (type) {
      case "primary":
        currentClassName = "pf-btn-primary";
        break;
      case "secondary":
        currentClassName = "pf-btn-secondary";
        break;
      case "transparent":
        currentClassName = "pf-btn-transparent";
        break;
      case "green":
        currentClassName = "pf-btn-green";
        break;
      case "red":
        currentClassName = "pf-btn-red";
        break;
      default:
        currentClassName = "pf-btn-primary";
        break;
    }
    return currentClassName;
  };

  return (
    <div style={{ width: isBlock ? currentWidth : null, float: floatRight ? "right" : null }} className={className}>
      <Button
        disabled={isDisabled}
        type={type}
        loading={isLoading}
        onClick={(event) => (!isDisabled && !!clickCallback ? clickCallback(event) : null)}
        size={currentSize}
        className={getCurrentClassName()}
        block={isBlock}
        icon={currentIcon}
        htmlType={htmlType}
      >
        {content}
      </Button>
    </div>
  );
};

PFButton.propTypes = {
  isDisabled: PropTypes.bool,
  type: PropTypes.string,
  content: PropTypes.string,
  clickCallback: PropTypes.func,
  isLoading: PropTypes.bool,
  isBlock: PropTypes.bool,
  currentSize: PropTypes.oneOf(["small", "middle", "large"]),
  currentIcon: PropTypes.object,
  currentWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  floatRight: PropTypes.bool,
  className: PropTypes.string,
};

export default PFButton;
